import React, { useEffect, useState } from "react";
import "./Logos.scss";
import toastr from "../../elements/toast";
import httpApiCall from "../../../service/api.service";
import { getStorageValue } from "../../../service/shared.service";
const toastrService = new toastr(true);
const token = getStorageValue("partnerToken");

const Logos = ({ tabactive }: any) => {
  const loader = false;
  const [credeeLogos, setCredeeLogos] = useState([]);

  useEffect(() => {
    callApi();
  }, []);

  const callApi = async () => {
    const AllLogos: any = await getCredeeLogo();
    if (AllLogos && AllLogos.data) {
      setCredeeLogos(AllLogos.data);
    }
  };
  const downloadFile = async (fileUrl: any, fileName: any) => {
    const originalImage = fileUrl;
    const image = await fetch(originalImage);

    // Split image name
    const nameSplit = originalImage.split("/");
    const duplicateName = nameSplit.pop();

    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.setAttribute('target', '_blank');
    link.href = imageURL;
    link.download = "" + duplicateName + "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {tabactive == 1 && (
        <>
          {!loader && (
            <div className="mt-md-5 outer--wrapper">
              <div className="row">
                {credeeLogos &&
                  credeeLogos.map((item: any, index: any) => (
                    <div
                      className="col-md-6 col-xl-4 col-12"
                      key={item.id}
                    >
                      <div className="logos-card--wrap">
                        <div>
                          <div className="logos-card--media">
                            <span>
                              <img
                                src={item.logo_url}
                                className="img-fluid"
                                alt=""
                              />
                            </span>
                          </div>
                          <div className="logos-card-bottom">
                            <div className="left">
                              <h5>Credee Logo {index + 1}</h5>
                            </div>
                            <span
                            // onClick={(e: any) =>
                            //   downloadFile(item.logo_url, "logo.png")
                            // }
                            >
                              <a className="text-decoration-none text-dark" download="logo.png" href={item.logo_url} target="_blank">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-download"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                </svg>
                              </a>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}

          {loader && (
            <div className="no_data">
              <img src="assets/gif/data-loading.gif" alt="" />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Logos;

const getCredeeLogo = async () => {
  try {
    const response = await httpApiCall({
      api: "get_credee_logos",
      type: "post",
      body: { access_token: token },
    });

    if (response && response.is_error == 0) {
      return response;
    } else {
      toastrService.showError(response.original_text || response.err);
    }
  } catch (error) {
    toastrService.showError(error);
  }
};
